// Query param master: page, max, finds[kolom], orders[kolom].

function isBlank(value) {
  return value === '' || value === null || value === undefined;
}

export function buildMasterParams({
  page = 1, max = 10, finds = {}, orders = {},
} = {}) {
  const params = { page, max };

  Object.keys(finds).forEach((key) => {
    const value = finds[key];
    if (isBlank(value)) return;
    if (Array.isArray(value)) {
      const kept = value.filter((item) => !isBlank(item));
      if (kept.length) params[`finds[${key}][]`] = kept;
      return;
    }
    params[`finds[${key}]`] = value;
  });

  Object.keys(orders).forEach((key) => {
    const value = orders[key];
    if (isBlank(value)) return;
    params[`orders[${key}]`] = value;
  });

  return params;
}

export function readPagination(body) {
  const rows = Array.isArray(body && body.data) ? body.data : [];
  const raw = (body && body.pagination) || {};
  return {
    page: Number(raw.page) || 1,
    pageSize: Number(raw.itemPerPage) || rows.length || 10,
    totalSize: Number(raw.totalData) || rows.length,
  };
}
